(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["info-row"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__infoRowsReady) return;
  window.__infoRowsReady = true;

  function speedOf(dialog) {
    var raw = getComputedStyle(dialog).getPropertyValue('--ir-speed').trim();
    if (!raw) return 320;
    var value = parseFloat(raw);
    if (isNaN(value)) return 320;
    return raw.indexOf('ms') > -1 ? value : value * 1000;
  }

  function openDrawer(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal !== 'function') return;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dialog.classList.add('is-open');
      });
    });
  }

  function closeDrawer(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-open');
    window.setTimeout(function () {
      if (dialog.open) dialog.close();
      document.documentElement.style.overflow = '';
    }, speedOf(dialog));
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-ir-open]');
    if (trigger) {
      event.preventDefault();
      openDrawer(document.getElementById(trigger.getAttribute('data-ir-open')));
      return;
    }

    var closer = target.closest('[data-ir-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('dialog.info-drawer'));
      return;
    }

    if (target.matches && target.matches('dialog.info-drawer')) {
      closeDrawer(target);
    }
  });

  document.addEventListener('cancel', function (event) {
    var dialog = event.target;
    if (dialog && dialog.matches && dialog.matches('dialog.info-drawer')) {
      event.preventDefault();
      closeDrawer(dialog);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
